<form [formGroup]="contactForm">
    <dx-load-panel
        shadingColor="rgba(0,0,0,0.4)"
        [(visible)]="isLoading"
        [showIndicator]="true"
        [showPane]="true"
        [shading]="true"
        [closeOnOutsideClick]="false">
    </dx-load-panel>
    <div id="contactForm" fxLayout="column" fxLayoutAlign="start center">
        <div class="content-block dx-card responsive-paddings ocl-top-container contact-block">
            <dx-toolbar id="navigation-header" style="padding-right: 26px!important; height: 50px!important;">
                <dxi-item location="before">
                    <h3 style="padding-left: 24px !important;">Contact Us</h3>
                </dxi-item>
                <dxi-item location="after" style="margin-top: 10px !important;">
                    <dx-button [text]="'Send'" [disabled]="!contactForm.valid" (click)="submit()"></dx-button>
                </dxi-item>
            </dx-toolbar>
        </div>
        <div class="content-block dx-card responsive-paddings ocl-bottom-container contact-block">
            <div style="padding: 16px;">
                <div fxLayout="column" fxLayoutAlign="start space-between">
                    <div fxLayout="column" fxLayoutAlign="start space-between">
                        <div fxLayout="row" class="dx-field">
                            <div class="dx-field-label">Last Name <span class="ocl-required-indicator">*</span></div>
                            <div class="dx-field-value">
                                <dx-text-box formControlName="lastName" class="uppercase">
                                    <dx-validator validationGroup="contactForm">
                                        <dxi-validation-rule type="required" message="Last name is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-text-box>
                            </div>
                        </div>
                        <div fxLayout="row" class="dx-field">
                            <div class="dx-field-label">First Name <span class="ocl-required-indicator">*</span></div>
                            <div class="dx-field-value">
                                <dx-text-box formControlName="firstName" class="uppercase">
                                    <dx-validator validationGroup="contactForm">
                                        <dxi-validation-rule type="required" message="First name is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-text-box>
                            </div>
                        </div>
                        <div fxLayout="row" class="dx-field">
                            <div class="dx-field-label">Email <span class="ocl-required-indicator">*</span></div>
                            <div class="dx-field-value">
                                <dx-text-box formControlName="email">
                                    <dx-validator validationGroup="contactForm">
                                        <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
                                        <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-text-box>
                            </div>
                        </div>
                        <div fxLayout="row" class="dx-field">
                            <div class="dx-field-label">Phone</div>
                            <div class="dx-field-value">
                                <dx-text-box formControlName="phone" maxLength="10" mask="000-000-0000" maskInvalidMessage="Phone is invalid">
                                    <dx-validator validationGroup="contactForm">
                                        <dxi-validation-rule type="pattern" [pattern]="phonePattern" message="Phone is invalid"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-text-box>
                            </div>
                        </div>
                        <div fxLayout="row" class="dx-field">
                            <div class="dx-field-label">Message <span class="ocl-required-indicator">*</span></div>
                            <div class="dx-field-value">
                                <dx-text-area formControlName="message" height="100px" (onInitialized)="onInitialized($event)">
                                    <dx-validator validationGroup="contactForm">
                                        <dxi-validation-rule type="required" message="Message is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-text-area>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
